<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}退库单</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">退库基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="退库单号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成退库单号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="出库单号" prop="warehouseOutStocksNo">
                <el-select
                  :disabled="!editMode"
                  v-model="form.warehouseOutStocksNo"
                  style="width: 90%"
                  filterable
                  placeholder="请选择出库单号"
                  :filter-method="getWarehouseOutStocks"
                  @change="deptWarehouseOutChange"
                >
                  <el-option
                    v-for="item in STATIC_WarehouseOutStocks.data"
                    :key="item.id"
                    :label="item.no"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="退库科室" prop="deptName">
                <el-select :disabled="!editMode" v-model="form.deptName" style="width: 90%" filterable placeholder="请选择退库科室" :filter-method="getDepts" @change="deptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="退库人" prop="userName">
                <el-select :disabled="!editMode" v-model="form.userName" style="width: 90%" filterable placeholder="请选择退库人" :filter-method="getUsersByDept" @change="userChange">
                  <el-option v-for="item in STATIC_DeptUsers" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="接收库房" prop="warehouseName">
                <el-select :disabled="!editMode" v-model="form.warehouseName" style="width: 90%" filterable placeholder="请选择接收库房" :filter-method="getWarehouses" @change="warehouseChange">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="库管员" prop="warehouseManagerName">
                <el-input disabled v-model="form.warehouseManagerName" placeholder="系统自动带出库管员" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createdUserName">
                <el-input v-model="form.createdUserName" disabled style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建日期" prop="createdTime">
                <el-date-picker disabled v-model="form.createdTime" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="系统默认为当前日期">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="退库总数量" prop="toTalNumber">
                <el-input disabled v-model="form.toTalNumber" placeholder="根据详细信息数量求和汇总" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="退库总金额" prop="totalAmount">
                <el-input disabled v-model="form.totalAmount" placeholder="根据详细信息金额求和汇总" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="退库原因" prop="reason">
                <el-input :disabled="!editMode" v-model="form.reason" placeholder="请填写退库原因" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <!-- 退库详情table -->
        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">退库详情信息</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" :data="form.details" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column show-overflow-tooltip type="selection" fixed width="50" align="center" />
            <el-table-column show-overflow-tooltip label="资产编码" align="center" min-width="140" prop="fixedAssetNo" />
            <el-table-column show-overflow-tooltip label="资产名称" align="center" min-width="130" prop="fixedAssetName" />
            <el-table-column label="资产卡号" align="center" min-width="200" prop="fixedAssetCards">
              <template slot-scope="scope">
                <el-tooltip effect="light" placement="bottom" popper-class="tooltip-content">
                  <div slot="content" class="">
                    <div class="tooltip-text" v-for="item in scope.row.assetCardInfos" :key="item.id">
                      {{ item.no }}
                    </div>
                  </div>
                  <span class="td-overflow-hidden">{{
                    scope.row.assetCardInfos
                      ? scope.row.assetCardInfos.map((e) => e.no).join(";")
                      : ""
                  }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="规格型号" align="center" min-width="130" prop="specName" />
            <el-table-column show-overflow-tooltip label="单位" align="center" min-width="80" prop="unitName" />
            <!-- <el-table-column show-overflow-tooltip label="品牌" align="center" min-width="100" prop="brandName" /> -->
            <el-table-column show-overflow-tooltip label="生产厂家" align="center" min-width="130" prop="manufacturerName" />
            <el-table-column show-overflow-tooltip label="供应商" align="center" min-width="130" prop="supplierName" />
            <el-table-column show-overflow-tooltip label="资产类型" align="center" min-width="130" prop="assetTypeName" />
            <el-table-column show-overflow-tooltip label="产地类型" align="center" min-width="80" prop="productionPlaceName" />
            <el-table-column show-overflow-tooltip label="库存数量" align="center" min-width="80" prop="number" />
            <el-table-column show-overflow-tooltip label="单价" align="center" min-width="80" prop="price" />
            <el-table-column show-overflow-tooltip label="金额" align="center" min-width="100" prop="amount" />
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

      <el-dialog title="资产信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
        <el-form label-position="top" ref="childForm" :model="childForm" :rules="childFormRules">
          <el-row>
            <el-col :span="6">
              <el-form-item label="资产编号" prop="fixedAssetNo">
                <SelectTable :disabled="!editMode" :columns="stockColumns" :placeholder="'请选择资产编号'" :innerName="childForm.fixedAssetNo" :dataList="STATIC_Stocks" @filterMethod="getFixedAssetList" @change="selectAsset" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产名称" prop="fixedAssetName">
                <el-input disabled v-model="childForm.fixedAssetName" placeholder="系统自动带出资产名称" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产卡号" prop="assetCardIdArr">
                <el-select :disabled="!editMode" v-model="childForm.assetCardIdArr" placeholder="请选择资产卡号" multiple collapse-tags :filter-method="getAssetCards" @change="cardChange" style="width: 100%">
                  <el-option v-for="item in STATIC_AssetCards" :key="item.id" :label="item.no" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="规格型号" prop="specName">
                <el-input disabled v-model="childForm.specName" placeholder="系统自动带出规格型号" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单位" prop="unitName">
                <el-input disabled v-model="childForm.unitName" placeholder="系统自动带出单位" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="品牌" prop="brandName">
                <el-input disabled v-model="childForm.brandName" placeholder="系统自动带出品牌" />
              </el-form-item>
            </el-col>
            <!-- </el-row>

          <el-row> -->
            <el-col :span="6">
              <el-form-item label="资产类型" prop="assetTypeName">
                <el-input disabled v-model="childForm.assetTypeName" placeholder="系统自动带出资产类型" />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="单位" prop="unitName">
                <el-input disabled v-model="childForm.unitName" placeholder="系统自动带出单位" />
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="数量" prop="number">
                <el-input-number disabled v-model="childForm.number" :min="childForm.maxNum" :precision="2" :controls="false" placeholder="请填写数量" @change="childNumberChange" style="width: 100%"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单价" prop="price">
                <el-input disabled v-model="childForm.price" placeholder="请填写单价" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产地类型" prop="productionPlaceName">
                <el-input disabled v-model="childForm.productionPlaceName" placeholder="系统自动带出产地类型" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产厂家" prop="manufacturerName">
                <el-input disabled v-model="childForm.manufacturerName" placeholder="系统自动带出生产厂家" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="供应商" prop="supplierName">
                <el-input disabled v-model="childForm.supplierName" placeholder="系统自动带出供应商" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button v-if="editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
          <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
        </div>
      </el-dialog>

      <!-- <el-image-viewer :openViewer="openViewer" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" /> -->
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetDeptClaimById,
  GetDeptInStockById,
  SaveDeptInStock,
  RejectDeptInStock,
  GetFixedAssetStockInfos,
  GetAssetInStockById,
  GetWarehouseOutStocks,
} from "@/api";
import { WarehouseOutStockOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin],
  components: {
    SelectTable,
    ApproveInfo,
  },
  data () {
    return {
      form: {},
      WarehouseOutStockOptions: WarehouseOutStockOptions,
      rules: {
        // warehouseOutStocksNo: [
        //   { required: true, message: "出库单号不能为空", trigger: "blur" },
        // ],
        deptName: [
          { required: true, message: "退库科室不能为空", trigger: "blur" },
        ],
        userName: [
          { required: true, message: "退库人不能为空", trigger: "blur" },
        ],
        warehouseName: [
          { required: true, message: "接收库房不能为空", trigger: "blur" },
        ],
      },
      childFormRules: {
        fixedAssetNo: [
          { required: true, message: "资产编码不能为空", trigger: "blur" },
        ],
        number: [{ required: true, message: "数量不能为空", trigger: "blur" }],
        assetCardIdArr: [
          { required: true, message: "资产卡号不能为空", trigger: "blur" },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      reject: RejectDeptInStock,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      openSubformModal: false,
      childForm: {},

      applyDetails: [],
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
      if (query.claimId) {
        this.form.deptClaimId = query.claimId;

        this.deptWarehouseOutChange(query.claimId);
      }
    }

    this.getUsersByDept("");
    this.getDepts("");
    this.getWarehouses("");
    // this.getFixedAssetList('')

    this.getDeptClaims("");
    this.getAssetInStocks("");
    this.getWarehouseOutStocks("");
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetDeptInStockById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;

        this.getFixedAssetList("");

        this.initWorkFlowProperty(this.form);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        if (this.form.outStockType == 0) {
          this.deptWarehouseOutChange(this.form.warehouseOutStockId);
        }
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveDeptInStock(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");

          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        outStockType: 0,
        supplierId: "",
        supplierName: "",
        warehouseId: "",
        warehouseName: "",
        state: 0,
        details: [],
        deptId: this.userInfo.deptId,
        deptName: this.userInfo.deptName,
        applyUserId: this.userInfo.id,
        applyUserName: this.userInfo.name,
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        reason: "",
        remark: "",
        orgCode :sessionStorage.getItem('orgId')
      };
      this.getFixedAssetList("");
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },
    autoTotalAmount () {
      let toTalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        toTalNumber = toTalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.toTalNumber = toTalNumber;
      this.form.totalAmount = totalAmount;
    },

    //=================== 明细表操作======================
    // 明细表
    handleAddChildForm () {
      if (!this.form.details) {
        this.form.details = [];
      }
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });
      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      this.$set(
        this.childForm,
        "assetCardIdArr",
        this.childForm.assetCardInfos?.map((e) => e.id)
      );
      this.getAssetCards("");
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        fixedAssetNo: "",
        fixedAssetName: "",
        name: "",
        number: 0,
        receivedNumber: 0,
        notReceivedNumber: 0,
        price: 0,
        amount: 0,
        remark: "",
        assetCardIds: "",
        assetCardIdArr: [],
        assetCardInfos: [],
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
    },
    pushChildForm (close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        // this.capitalSourceChange()
        let item = this.form.details.find(
          (e) =>
            e.assetId == this.childForm.assetId &&
            e.price == this.childForm.price &&
            e.locationName == this.childForm.locationName &&
            e.assetSource == this.childForm.assetSource &&
            e.packDesc == this.childForm.packDesc &&
            e.manufacturerId == this.childForm.manufacturerId &&
            e.certId == this.childForm.certId &&
            e.brandId == this.childForm.brandId
        );
        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前退库信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    childNumberChange () {
      if (this.childForm.maxAmount) {
        if (this.childForm.number > this.childForm.maxAmount) {
          this.childForm.number = this.childForm.maxAmount;
        }
      }
      this.autoAmount();
      this.childForm.notReceivedNumber = this.childForm.number;
    },
    autoAmount () {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(2) * 1;
    },
    // change event
    selectAsset (row) {
      window.console.log(row);
      this.childForm = Object.assign(this.childForm, row, {
        // fixedAssetNo: row.no,
        // fixedAssetName: row.name,
        // assetId: row.assetId,
        unitId: row.unitId,
        unitName: row.unitName,
        number: 1,
        amount: row.price,
        stockDetailId: row.id,
        remark: "",
        id: 0,
        maxAmount: row.amount,
        stockState: row.state,
      });

      this.getAssetCards("");
    },
    cardChange (val) {
      if (val && val.length > 0) {
        this.childForm.assetCardIds = val.join(";");

        let isAdd = false;
        // 判断是新增还是删除
        for (let i = 0; i < val.length; i++) {
          if (!this.childForm.assetCardInfos) {
            this.childForm.assetCardInfos = [];
          }
          let item = this.childForm.assetCardInfos.find((e) => e.id == val[i]);
          if (item == null) {
            isAdd = true;
            let obj = this.STATIC_AssetCards.find((e) => e.id == val[i]);
            if (obj) {
              this.childForm.assetCardInfos.push(obj);
            }
            break;
          }
        }

        // 删除
        if (!isAdd) {
          this.childForm.assetCardInfos = this.childForm.assetCardInfos.filter(
            (i) => val.indexOf(i.id) != -1
          );
        }
      } else {
        this.childForm.assetCardIds = "";
        this.childForm.assetCardInfos = [];
      }
      this.childForm.maxNum = this.childForm.assetCardInfos.length;
      this.childForm.number = this.childForm.assetCardInfos.length;
    },
    getFixedAssetList (keyWord) {
      this.GetStocksContainDetailByQuery({
        keyWord: keyWord,
        deptId: this.form.deptId,
      });
    },
    getAssetCards (keyWord) {
      this.getAssetCardsByQuery({
        keyWord: keyWord,
        stockDetailId: this.childForm.stockDetailId,
        category: "1",
        states: [0, 1],
        deptId: this.form.deptId,
      }).then((res) => {
        if (
          this.childForm.assetCardInfos &&
          this.childForm.assetCardInfos.length > 0
        ) {
          this.childForm.assetCardInfos.forEach((item) => {
            let o = this.STATIC_AssetCards.find((e) => e.id == item.id);
            if (!o) {
              this.STATIC_AssetCards.push(item);
            }
          });
        }
      });
    },
    //=================== 明细表操作======================

    dutyDeptChange (val) {
      this.form.dutyDeptId = val;
    },
    deptChange (val) {
      this.form.deptId = val;
      this.getFixedAssetList("");
      this.getAssetCards("");
      this.getUsersByDept();
    },
    dutyUserChange (val) {
      this.form.dutyUserId = val;
    },
    userChange (val) {
      this.form.userId = val;
    },
    warehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.warehouseId = item.id;
        this.form.warehouseManagerId = item.managerId;
        this.form.warehouseManagerName = item.managerName;
      }
    },
    deptWarehouseOutChange (val) {
      this.form.warehouseOutStockId = val;
      let item = this.STATIC_WarehouseOutStocks.data.find((e) => e.id == val);
      // GetDeptClaimById({ id: val }).then((res) => {
      //   this.form.deptClaimNo = res.returnData.no;
      //   this.form.claimDeptName = res.returnData.deptName;
      //   this.form.claimDeptId = res.returnData.deptId;
      //   this.form.claimUserId = res.returnData.applyUserId;
      //   this.form.claimUserName = res.returnData.applyUserName;
      //   this.form.warehouseId = res.returnData.warehouseId;
      //   this.form.warehouseName = res.returnData.warehouseName;
      //   this.form.warehouseManagerId = res.returnData.warehouseManagerId;
      //   this.form.warehouseManagerName = res.returnData.warehouseManagerName;

      //   this.applyDetails = res.returnData.details;

      //   this.getFixedAssetList("");
      // });
    },
    inStockChange (val) {
      this.form.assetInStockId = val;
      GetAssetInStockById({ id: val }).then((res) => {
        this.form.warehouseId = res.returnData.warehouseId;
        this.form.warehouseName = res.returnData.warehouseName;
        this.form.warehouseManagerId = res.returnData.warehouseManagerId;
        this.form.warehouseManagerName = res.returnData.warehouseManagerName;

        this.getFixedAssetList("");
      });
    },
    outStockTypeChange () {
      this.form.warehouseOutStockId = "";
      this.form.warehouseOutStocksNo = "";
      this.form.assetInStockId = "";
      this.form.assetInStockNo = "";
      this.applyDetails = [];
      this.form.details = [];
    },
    getUsersByDept (keyWord) {
      this.getDeptUsers(this.form.deptId, keyWord);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
